import type { EntryDateSelection } from '@libs/enums';
import { entryDateSelection } from '@libs/enums';
import { calculateEndingYearMonth } from './calcEndingYearMonth';

function calcSpecifyInputCondition(
  processingMonth: Date,
  beginningYearMonth: Date,
  specifySelectionCondition: EntryDateSelection,
) {
  const endingYearMonth = calculateEndingYearMonth(beginningYearMonth);
  const quarter1Start = new Date(beginningYearMonth);
  const quarter2Start = new Date(beginningYearMonth);
  const quarter3Start = new Date(beginningYearMonth);
  const quarter4Start = new Date(beginningYearMonth);
  quarter2Start.setMonth(beginningYearMonth.getMonth() + 3);
  quarter3Start.setMonth(beginningYearMonth.getMonth() + 6);
  quarter4Start.setMonth(beginningYearMonth.getMonth() + 9);
  const quarter1End = new Date(beginningYearMonth);
  const quarter2End = new Date(beginningYearMonth);
  const quarter3End = new Date(beginningYearMonth);
  const quarter4End = new Date(endingYearMonth);
  quarter1End.setMonth(beginningYearMonth.getMonth() + 2);
  quarter2End.setMonth(beginningYearMonth.getMonth() + 5);
  quarter3End.setMonth(beginningYearMonth.getMonth() + 8);
  const quarter1Result = { from: quarter1Start, to: quarter1End };
  const quarter2Result = { from: quarter2Start, to: quarter2End };
  const quarter3Result = { from: quarter3Start, to: quarter3End };
  const quarter4Result = { from: quarter4Start, to: quarter4End };

  switch (specifySelectionCondition) {
    case entryDateSelection.enum.currentMonth:
      return { from: processingMonth, to: processingMonth };
    case entryDateSelection.enum.currentQuarter:
      if (processingMonth > quarter3End) {
        return quarter4Result;
      }
      if (processingMonth > quarter2End) {
        return quarter3Result;
      }
      if (processingMonth > quarter1End) {
        return quarter2Result;
      }
      return quarter1Result;
    case entryDateSelection.enum.currentHalf:
      if (processingMonth > quarter2End) {
        return { from: quarter3Start, to: endingYearMonth };
      }
      return { from: beginningYearMonth, to: quarter2End };
    case entryDateSelection.enum.currentPeriod:
      return { from: beginningYearMonth, to: endingYearMonth };
    case entryDateSelection.enum.quarter1:
      return quarter1Result;
    case entryDateSelection.enum.quarter2:
      return quarter2Result;
    case entryDateSelection.enum.quarter3:
      return quarter3Result;
    case entryDateSelection.enum.quarter4:
      return quarter4Result;
  }
}

export { calcSpecifyInputCondition };
